import { SupplementaryInsuranceTypes } from '../../../../core/states/offer/offer.state';
import { Action } from '@ngrx/store';
import {
  deselectAccidentDeathCapitalProduct,
  deselectAccidentDisabilityCapitalProduct,
  deselectAccidentMedicalExpensesSupplementProduct,
  deselectBasicProduct,
  deselectComplementaryProduct,
  deselectDailyCashProduct,
  deselectDentalProduct,
  deselectEmergencyCareProduct,
  deselectHospitalCapitalProduct,
  deselectHospitalDailyCashProduct,
  deselectHospitalProduct,
  deselectLegalProtectionProduct,
  deselectOutpatientProduct,
  deselectSicknessDeathOrDisabilityCapitalProduct,
} from '../../../../core/states/offer/supplementary-insurance/actions';

export type TypedAction<T> = Action & { type: T };

interface PersonId {
  personId: number;
}

export const supplementaryInsuranceDeselectActionMap: {
  [key in SupplementaryInsuranceTypes]-?: (personId: PersonId) => PersonId & TypedAction<string>;
} = {
  basic: deselectBasicProduct,
  hospital: deselectHospitalProduct,
  complementary: deselectComplementaryProduct,
  outpatient: deselectOutpatientProduct,
  hospitalCapital: deselectHospitalCapitalProduct,
  accidentDeathCapital: deselectAccidentDeathCapitalProduct,
  accidentDisabilityCapital: deselectAccidentDisabilityCapitalProduct,
  sicknessDeathOrDisabilityCapital: deselectSicknessDeathOrDisabilityCapitalProduct,
  legalProtection: deselectLegalProtectionProduct,
  dental: deselectDentalProduct,
  hospitalDailyCash: deselectHospitalDailyCashProduct,
  dailyCash: deselectDailyCashProduct,
  emergencyCare: deselectEmergencyCareProduct,
  accidentMedicalExpensesSupplement: deselectAccidentMedicalExpensesSupplementProduct,
};
